/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Kde je moje objednávka?`
};

const da_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Hvor er min ordre?`
};

const de_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Wo ist meine Bestellung?`
};

const en_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Where is my order?`
};

const es_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `¿Dónde está mi pedido?`
};

const fr_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Où en est ma commande ?`
};

const hu_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Hol van a rendelésem?`
};

const it_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Dov'è il mio ordine?`
};

const nl_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Waar is mijn bestelling?`
};

const pl_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Gdzie jest moje zamówienie?`
};

const pt_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Onde está meu pedido?`
};

const sv_contact_subjects_delivery_time = /** @type {(inputs: {}) => string} */ () => {
	return `Var är min beställning?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_delivery_time = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_delivery_time(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_delivery_time", locale)
	if (locale === "cs") return cs_contact_subjects_delivery_time(inputs)
	if (locale === "da") return da_contact_subjects_delivery_time(inputs)
	if (locale === "de") return de_contact_subjects_delivery_time(inputs)
	if (locale === "en") return en_contact_subjects_delivery_time(inputs)
	if (locale === "es") return es_contact_subjects_delivery_time(inputs)
	if (locale === "fr") return fr_contact_subjects_delivery_time(inputs)
	if (locale === "hu") return hu_contact_subjects_delivery_time(inputs)
	if (locale === "it") return it_contact_subjects_delivery_time(inputs)
	if (locale === "nl") return nl_contact_subjects_delivery_time(inputs)
	if (locale === "pl") return pl_contact_subjects_delivery_time(inputs)
	if (locale === "pt") return pt_contact_subjects_delivery_time(inputs)
	return sv_contact_subjects_delivery_time(inputs)
};
export { contact_subjects_delivery_time as "contact.subjects.delivery_time" }